export class JwtUtils {
    static isJwtValid(token?: string | null): boolean {
        if (!token) {
            return false;
        }

        const exp = this.tryReadJwtExpSeconds(token);
        if (!exp) {
            return false;
        }

        const nowSeconds = Math.floor(Date.now() / 1000);
        return exp > (nowSeconds + 15);
    }

    private static tryReadJwtExpSeconds(token: string): number | null {
        const parts = token.split('.');
        if (parts.length < 2) {
            return null;
        }

        try {
            const payload = parts[1]
                .replace(/-/g, '+')
                .replace(/_/g, '/');

            const json = atob(this.padBase64(payload));
            const obj = JSON.parse(json) as { exp?: number };

            return typeof obj.exp === 'number' ? obj.exp : null;
        } catch {
            return null;
        }
    }

    private static padBase64(input: string): string {
        const pad = input.length % 4;
        if (pad === 0) {
            return input;
        }
        return input + '='.repeat(4 - pad);
    }
}